<template>
    <entity-list entity="systemPage" api-name="systemPages" :filter-all="true" :entity-archive-headers="archiveHeaders">
        <template v-slot:[`currentList`]="{ entities, searchTerm, readRoute }">
            <v-data-table
                :headers="headers"
                :items="entities"
                :items-per-page="15"
                dense
                class="elevation-1"
                :search="searchTerm"
                :footer-props="{
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:[`item.name`]="{ item }">
                    <router-link :to="{ name: readRoute, params: { id: item.keyId } }" :title="item.name">
                        {{ item.name }}
                    </router-link>
                </template>
            </v-data-table>
        </template>
        <template v-slot:[`archiveList`]="{ entities, searchTerm, readRoute }">
            <v-data-table
                :headers="archiveHeaders"
                :items="entities"
                :items-per-page="15"
                dense
                class="elevation-1"
                :search="searchTerm"
                :footer-props="{
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:[`item.reference`]="{ item }">
                    <router-link :to="{ name: readRoute, params: { id: item.keyId } }" :title="item.reference">
                        {{ item.reference }}
                    </router-link>
                </template>
                <template v-slot:[`item.archiveDate`]="{ item }">
                    {{ item.archiveDate | luxonSortableDateTime }}
                </template>
            </v-data-table>
        </template>
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
import api from '@/api'
export default {
    name: 'ResearchHomeList',
    components: {
        'entity-list': EntityList,
    },
    data() {
        return {
            researchPeriods: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '75%',
                },
                { text: 'Status', value: 'statusText', filterable: false, width: '25%' },
            ],
            archiveHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '75%',
                },
                { text: 'Archive Date', value: 'archiveDate', filterable: false, width: '20%' },
            ],
        }
    },
    mounted() {
        this.getResearchPeriods()
    },
    methods: {
        getResearchPeriods() {
            this.isLoading = true
            api.get('researchPeriod/getAll')
                .then(res => {
                    this.researchPeriods = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
